import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Card, Table, Empty, Divider, List, Menu } from 'antd';
import 'moment/locale/ru';
import Action from '../../components/Action'
import Filtered from '../../components/Filtered'
import DropdownAction from '../../components/DropdownAction'
import { unwrap, GET, errorCatch, Request, fire } from '../../components/Tool'
import Icofont from 'react-icofont';
import { createUseStyles } from 'react-jss';
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';
import "./index.css"
import Modal from 'antd/lib/modal/Modal';

var _ = require('lodash');

const DragHandle = sortableHandle(() => <Icofont icon="expand-alt" style={{ cursor: 'grabbing', color: '#999' }} />);
const SortableItem = sortableElement(props => <tr {...props} />);
const SortableContainer = sortableContainer(props => <tbody {...props} />);

const useStyles = createUseStyles({
    collapse: {
        '& .ant-collapse-content > .ant-collapse-content-box': {
            padding: "0px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow': {
            top: "-3px",
            left: "10px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header': {
            padding: "4px 10px",
            paddingLeft: "30px"
        }
    },
    cardSmall: {
        '& .ant-card-body': {
            padding: "0px"
        }
    },
    smallTable: {
        '& .ant-table .ant-table-tbody > tr > td': {
            padding: "4px 8px",
            fontSize: '12px'
        },
        '& .ant-table .ant-table-thead > tr > th': {
            padding: "4px 8px",
            fontSize: "13px"
        }
    },
    whiteCell: {
        '&.ant-table-cell-fix-right': {
            backgroundColor: "white"
        }
    }
})

export default function Collection(props) {
    const classes = useStyles()
    const dispatch = useDispatch();
    const {
        auth,
        source,
        data,
        title,
        size,
        modelActions,
        collectionActions,
        noPrint,
        noPagination,
        selection, // undefined, "radio" или "checkbox"
        mode, // table, list
        listRenderItem,
        ordering
    } = props;

    // ordering: {
    //     field : "sort",
    //     action: {
    //          method: "POST",
    //          path: "/api/...",
    //          mutation: "upgrade",
    //     }
    // }

    const [loading, setLoading] = useState(false);
    const [collection, setCollection] = useState(data || []);

    const orderingField = (r) => {
        if (ordering && ordering.field) {
            if (_.isString(ordering.field)) {
                return r[ordering.field];
            }
        }
        return r.ID;
    }
    const setOrderedCollection = (collection) => {
        const data = (ordering) ? collection.sort((a, b) => {
            return orderingField(a) - orderingField(b);
        }).map((item, index) => {
            return { ...item, [ordering.field]: index };
        }) : collection;

        setCollection(data);
    };
    const lock = () => {
        setLoading(true);
    };
    const unlock = () => {
        setLoading(false);
    };
    useEffect(() => {
        if (data) {
            setOrderedCollection(data);
        } else {
            GET(auth, source,
                ({ data }) => {
                    setOrderedCollection(data);
                    unlock();
                },
                (err, type) => errorCatch(err, type, () => unlock)
            );
        }
    }, [data]);

    // Table Items Selection
    const [selectionType, setSelectionType] = useState(selection || 'checkbox'); // radio
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    useEffect(() => {
        setSelectionType(selection);
    }, [selection]);

    // Events
    const {
        // Collection Only Events
        onChange,   // |
        value,      // | AntFrom Item Api
        getSelectedOnly,

        // Collection and Model Events
        onValues, // (values, context) => { }, // если без return то просто как событие, если внутри return то замена данных
        onData,   // (values, context) => { }, // если без return то просто как событие, если внутри return то замена данных
        onClose,   // ({unlock, close}, context) => { },
        onError,  // (err, type, {unlock, close}) => {},
        onDispatch, // (values, context) => {}, // если не возвращает значения то посленеё будет вызван внутренний setCollection, 
        // если вернет функцию в качестве значения то эта функция будет вызвана вместо setCollection 
        // и в неё будет передано значение нового состояния
    } = props;

    // ---- AntFrom Item Api ----
    const [currentValue, setCurrentValue] = useState(value || []);
    useEffect(() => {
        setCurrentValue(value);
    }, [value]);
    const triggerChange = (value) => {
        if (onChange) {
            onChange(value);
        }
    };
    //---------------------------

    const filters = () => {
        var f = (props.filters) ? props.filters() : [];
        return f;
    };
    const columns = () => {
        var c = [];
        if (ordering) {
            c.push({
                width: 30,
                fixed: 'left',
                className: 'drag-visible',
                render: () => <DragHandle />,
            });
        }
        let tmp = (props.columns) ? props.columns({
            auth,
            collection,
            setCollection: setOrderedCollection,
            request: (values, itemAction) => Request(values, itemAction, {
                auth,
                collection,
                setCollection: setOrderedCollection,
                onData: onData || ((values, context) => values.data),

                // index,
                lock,
                unlock,
                // close,
                onValues,
                onClose,
                onError,
                onDispatch
            })
        }) : [];
        for (let i = 0; i < tmp.length; i++) {
            const cx = tmp[i];
            c.push(cx);
        }
        if (modelActions) {
            c.push({
                className: classes.whiteCell,
                title: '',
                dataIndex: '',
                key: 'x',
                fixed: 'right',
                width: 45,
                render: (text, record, index) => RenderOnModelActions(record, index)
            });
        }
        return c;
    };
    const intermediate = (values, unlock, close, item, index) => {
        return Request(values, item, {
            auth,
            collection,
            setCollection: setOrderedCollection,
            onData: onData || ((values, context) => values.data),

            index,
            unlock,
            close,
            onValues,
            onClose,
            onError,
            onDispatch
        })
    };
    const RenderOnModelActions = (item, index) => {
        if (!modelActions) return <></>;
        let values = unwrap(modelActions(item, index));
        if (!values || !values.length) return <></>;
        return <DropdownAction items={
            values.map((e, idx) =>
            ({
                auth: auth,
                mode: "func",
                // trigger: (click) => <div onClick={click}>{e.title}</div>,
                mode: "MenuItem",
                object: item,
                ...{
                    ...e,
                    action: (values, unlock, close) => intermediate(values, unlock, close, e, idx),
                }
            }))}
        />;
    };
    const RenderOnCollectionActions = () => {
        if (!collectionActions) return <></>;
        let values = unwrap(collectionActions());
        if (!values || !values.length) return <></>;
        return <div>
            {values.map((e, idx) => <Action
                key={idx}
                auth={auth}
                mode={"button"}
                {...{
                    ...e,
                    action: (values, unlock, close) => intermediate(values, unlock, close, e, idx),
                }}
            />)}
        </div>;
    };
    //------------ Ordering ---------------------------------------------------------------------
    const DraggableContainer = props => (
        <SortableContainer
            useDragHandle
            disableAutoscroll
            helperClass="row-dragging"
            onSortEnd={({ oldIndex, newIndex }) => {
                if (oldIndex !== newIndex) {
                    const _data = arrayMoveImmutable([].concat(collection), oldIndex, newIndex).filter(el => !!el);
                    Request(_data, ordering, {
                        auth,
                        collection,
                        setCollection: setOrderedCollection,
                        onData: (values, context) => values.data,

                        unlock: () => { },
                        close: () => { }
                    });
                }
            }}
            {...props}
        />
    );
    const DraggableBodyRow = ({ className, style, ...restProps }) => {
        const index = collection.findIndex(x => orderingField(x) === restProps['data-row-key']);
        return <SortableItem index={index} {...restProps} />;
    };
    //-------------------------------------------------------------------------------------------
    const hasSelected = selectedRowKeys.length > 0;
    const selectionConfig = (selectionType) => {
        if (!selection) return {};
        return {
            rowSelection: {
                type: selectionType,
                selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    setSelectedRowKeys(selectedRowKeys);
                    setSelectedRows(selectedRows);
                    if (!getSelectedOnly) {
                        triggerChange(_.unionBy([...value], selectedRows, 'ID'));
                    } else {
                        triggerChange(selectedRows);
                    }
                },
            }
        }
    };
    const onSelection = (item, index) => {
        if (!selection) return {};
        let sr = selectedRows.filter(e => e.ID !== item.ID);
        let srk = selectedRowKeys.filter(e => e !== item.ID);
        let vsr = value.filter(e => e.ID !== item.ID);
        if (sr.length !== selectedRows.length) {
            setSelectedRowKeys(srk);
            setSelectedRows(sr);
            if (!getSelectedOnly) {
                triggerChange(_.unionBy([...vsr], sr, 'ID'));
            } else {
                triggerChange(sr);
            }
        } else {
            let v = [...sr, item];
            setSelectedRowKeys([...srk, item.ID]);
            setSelectedRows(v);
            if (!getSelectedOnly) {
                triggerChange(_.unionBy([...vsr], v, 'ID'));
            } else {
                triggerChange(v);
            }
        }
    };
    const isSelected = (item) => {
        let v = selectedRows.find(e => e.ID === item.ID);
        return v !== undefined
    };
    const view = (items) => {
        if (mode === "list") {
            const render = (item, index) => {
                if (listRenderItem) {
                    return listRenderItem(item, index);
                }
                return "" + item
            };
            const actions = (item, index) => {
                let values = unwrap(modelActions(item, index));
                if (modelActions && values && values.length) {
                    return {
                        actions: [RenderOnModelActions(item, index)]
                    };
                }
                return {};
            };
            return (
                <List
                    locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" /> }}
                    itemLayout="horizontal"
                    dataSource={items}
                    renderItem={((item, index) => (
                        <List.Item {...actions(item, index)} style={{ backgroundColor: (isSelected(item)) ? "#e6f7ff" : "transparent", alignItems: "self-start" }} onClick={() => onSelection(item, index)}>
                            {render(item, index)}
                        </List.Item>
                    ))} />
            );
        }
        return (
            <Table
                scroll={{ x: "auto" }}
                loading={loading}
                pagination={false}
                columns={columns()}
                dataSource={(items && items.length) ? items : undefined}
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"Нет данных"}></Empty> }}
                size="small"
                {...((!ordering) ? { rowKey: (r) => r.ID } : {
                    rowKey: r => orderingField(r),
                    components: {
                        body: {
                            wrapper: DraggableContainer,
                            row: DraggableBodyRow,
                        },
                    }
                })}
                {...selectionConfig(selectionType)}
            />
        );
    };

    return (
        <>
            <Filtered
                noPrint={noPrint}
                noPagination={noPagination || ordering}
                size={size}
                filters={(!ordering) ? filters() : []}
                data={collection}
                addition={RenderOnCollectionActions()}
                content={items => {
                    return (
                        <Card size="small" bordered={(size !== "small")} className={(size === "small") ? classes.cardSmall : ""} style={{ width: "100%" }}>
                            <div>
                                {(title) ? <Divider type="horizontal" orientation="left">{title}</Divider> : <></>}
                                {view(items)}
                            </div>
                        </Card>
                    )
                }} />
        </>
    );
}